import { render, staticRenderFns } from "./Dplayer.vue?vue&type=template&id=7c22f548&scoped=true"
import script from "./Dplayer.vue?vue&type=script&lang=js"
export * from "./Dplayer.vue?vue&type=script&lang=js"
import style0 from "./Dplayer.vue?vue&type=style&index=0&id=7c22f548&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c22f548",
  null
  
)

export default component.exports